export enum HttpStatusCode {
  Ok = 200,
  BrokenRule = 400,
  FailedLogin = 401,
  Unauthorized = 403,
  InvalidToken = 406,
  UnknownError = 500,
  ServiceUnavailable = 503,
}
